module.exports = __webpack_public_path__ + "static/m_solution8-4c932678ad953e7ed941e8de7f3d3073.png";